module.exports = __webpack_public_path__ + "src/client/components/LandingPage/img/ornament-right-white.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/components/LandingPage/img/ornament-right-white.png
// module id = 1223
// module chunks = 0